module.exports = __webpack_public_path__ + "img/intro_end.d1d10cca.jpg";